var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockedUpReward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    fill: "#CFA809",
    fillOpacity: 0.35
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2805 14.7542L21.8613 17.4433H18.5316C17.5277 17.4433 16.7146 16.6302 16.7146 15.6263C16.7146 14.6224 17.5277 13.8093 18.5316 13.8093H18.6315C19.3084 13.8093 19.9398 14.1682 20.2805 14.7542ZM14.5342 15.6263C14.5342 16.2805 14.6932 16.8982 14.9703 17.4433H13.0806C12.2765 17.4433 11.627 18.0929 11.627 18.8969V21.8042C11.627 22.6082 12.2765 23.2578 13.0806 23.2578H33.4311C34.2351 23.2578 34.8847 22.6082 34.8847 21.8042V18.8969C34.8847 18.0929 34.2351 17.4433 33.4311 17.4433H31.5414C31.8185 16.8982 31.9775 16.2805 31.9775 15.6263C31.9775 13.4187 30.1877 11.6289 27.98 11.6289H27.8801C26.431 11.6289 25.0865 12.3966 24.3506 13.6458L23.2558 15.5128L22.1611 13.6503C21.4252 12.3966 20.0806 11.6289 18.6315 11.6289H18.5316C16.3239 11.6289 14.5342 13.4187 14.5342 15.6263ZM29.7971 15.6263C29.7971 16.6302 28.9839 17.4433 27.98 17.4433H24.6504L26.2312 14.7542C26.5764 14.1682 27.2033 13.8093 27.8801 13.8093H27.98C28.9839 13.8093 29.7971 14.6224 29.7971 15.6263ZM13.0806 24.7114V32.7062C13.0806 33.91 14.0572 34.8866 15.261 34.8866H21.8022V24.7114H13.0806ZM24.7094 34.8866H31.2507C32.4544 34.8866 33.4311 33.91 33.4311 32.7062V24.7114H24.7094V34.8866Z",
    fill: "#E5B910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedUpReward);
export default __webpack_public_path__ + "static/media/locked-up-reward.de1e53617979cb13855d1cfb0654be23.svg";
export { ForwardRef as ReactComponent };